module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-add-map",
      "title": "Aggiungi Mappe"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09408f7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddMap.vue
// module id = 817
// module chunks = 39